import axios from 'axios';
const EventBus = window.EventBus;

export const SpaVehicleCard = {
  props: ['vehicle', 'templatedir', 'lang','galleryinteraction', 'comingsoon', 'count', 'imagesForModels', 'gutembergOptions', 'cardCachebuster', 'useVin','similar'],
  data(){
        return {
          picture: null,
          secondPicture: this.getSecondPicture(this.vehicle.id),
          secondPictureWebp: this.getSecondPictureWebp(this.vehicle.id),
          allPictures: this.getAllPictures(this.vehicle.id),
          modelSelected: this.getImagesForModel(),
          discountsDetailsVisibility: false,
          discountsStatus: 'closed',
          msrpDisclaimerVisibility: false,
          msrpDisclaimerStatus: 'closed',
          discountsRebates: false,
          specialDiscounts: 0,
          myCachebuster: this.cardCachebuster || false,
          useVinSlug: this.useVin || false,
          isSimilar: this.similar || false
        }
  },
  mounted(){

    if(this.vehicle.special){
      if(this.vehicle.saleprice > this.vehicle.specialprice){
        this.specialDiscounts = this.vehicle.saleprice - this.vehicle.specialprice;
      }
    }

    if (this.vehicle.picture) {
      this.getFirstPicture(this.vehicle.picture, (result) => {
        this.picture = this.addCachebusterToken(result); // Asignar el valor de manera asíncrona
      });
    } else {
      this.picture = this.addCachebusterToken(this.templatedir); // Asignar el valor directamente si no hay asíncronía
    }
  },
  created(){
    if(this.comingsoon == true && this.vehicle.incoming == true)
      this.templatedir = this.templatedir.split('-photo').join('-photo-incoming');
    if(!this.secondPicture)
      this.secondPicture = 0;
    if(!this.secondPictureWebp)
      this.secondPictureWebp = 0;
    if(!this.allPictures)
      this.allPictures =  0;
  },
  methods: {
    goToVDP(viewSlug){
      window.location.href = viewSlug;
    },
    copyToClipboard(event,type) {
      try {
        if (event) {
          event.stopPropagation();
          if (event.target && event.target.innerHTML !== undefined) {
            var copyText = event.target.innerHTML;
            var textArea = document.createElement("textarea");
            textArea.value = copyText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("Copy");
            textArea.remove();

            if (type && type == 'vin') { 
              document.getElementById("lbx-vc-vin-custom-tooltip-"+this.vehicle.vin).style.display = "inline";
            }
            else if (type && type == 'stock') { 
              document.getElementById("lbx-vc-stock-custom-tooltip-"+this.vehicle.stocknumber).style.display = "inline";
            }

            setTimeout(() => {
              if (type && type == 'vin') { 
                document.getElementById("lbx-vc-vin-custom-tooltip-"+this.vehicle.vin).style.display = "none";
              }
              else if (type && type == 'stock') { 
                document.getElementById("lbx-vc-stock-custom-tooltip-"+this.vehicle.stocknumber).style.display = "none";
              }
            }, 2000);
          }
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    discountsDetailsOpen(event){
      event.stopPropagation();
      this.discountsRebates = false;
      this.discountsDetailsVisibility = false;
      this.discountsDetailsVisibility = !this.discountsDetailsVisibility;
      this.discountsStatus = 'open';
      this.$nextTick(() => {
        this.getDiscountsInfo(this.vehicle.id);
      });
    },
    discountsDetailsClose(event){
      event.stopPropagation();
      if (this.discountsStatus =='open'){
        this.discountsDetailsVisibility = false
        this.discountsStatus = 'closed'
      }
    },
    msrpDisclaimerOpen(event){
      event.stopPropagation();
      this.msrpDisclaimerVisibility = false;
      this.msrpDisclaimerVisibility = !this.msrpDisclaimerVisibility;
      this.msrpDisclaimerStatus = 'open';
    },
    msrpDisclaimerClose(event){
      event.stopPropagation();
      if (this.msrpDisclaimerStatus =='open'){
        this.msrpDisclaimerVisibility = false
        this.msrpDisclaimerStatus = 'closed'
      }
    },
    getDiscountsInfo(vehicleId) {
      if(vehicleId && vehicleId != undefined){
        var urlDetail = `${window.location.origin}/wp-content/uploads/data/${vehicleId}.json?v=${EventBus.getJSONTimestamp(5, 'Detail')}`;

          axios.get(urlDetail)
          .then(({ data }) => {

            if(data.rebates && data.rebates.length > 0){
              this.discountsRebates = data.rebates;
            } else {
              this.discountsRebates = [];
            }

            if(data.special){
              if(data.saleprice > data.specialprice){
                this.discountsRebates.push({calculationtype: "special_discount", calculatedvalue: this.specialDiscounts});
              }
            }
          })
      }
    },
    verifyRebateToTranslate(rebate) {
      const idiom = this.lang;
      
      if (idiom.includes('en')) {
        return rebate;
      }
    
      const lowerRebate = rebate.toLowerCase();
    
      if (lowerRebate.includes('delivery allowance')) {
        return 'Rabais à la livraison';
      }
    
      if (lowerRebate.includes('ev rebate retail')) {
        return 'Rabais gouvernement VE';
      }
    
      return rebate;
    },    
    showTooltip(type) {
      if(this.$refs[type] && this.$refs[type][0].classList){
        this.$refs[type][0].classList.remove('invisible');
        this.$refs[type][0].classList.add('visible');
        this.$refs[type][0].style.opacity = '100';
      }
    },
    hideTooltip(type) {
      if(this.$refs[type] && this.$refs[type][0].classList){
        this.$refs[type][0].classList.remove('visible');
        this.$refs[type][0].classList.add('invisible');
        this.$refs[type][0].style.opacity = '0';
      }
    },
    vehicleSlugPart(vin = false) {
      const parts = [
        this.vehicle.condition.toLowerCase().replace(/ /g, "-"),
        this.vehicle.year.toLowerCase().replace(/ /g, "-"),
        this.vehicle.make.toLowerCase().replace(/ /g, "-"),
        this.vehicle.model.toLowerCase().replace(/ /g, "-").replace('/', '')
      ];
    
      if (vin) {
        parts.push(this.vehicle.vin);
      }
    
      parts.push(this.vehicle.id);
    
      return parts.join("-");
    },
    trackEvent() {
      var data = this.vehicle.year + '-' +
      this.vehicle.make + '-' +
      this.vehicle.model + '-' +
      this.vehicle.trim + '-' +
      this.vehicle.stocknumber;

      var payload = {event_category: 'LBX-VDP', event_label: 'LBX-' + data};
      window.sendGAEvent('LBX-View-Click', payload);
    },
    getImagesForModel(){
      if(this.imagesForModels){
        let actualUrl = window.location.pathname.split("/");
        if(actualUrl.indexOf("model") >= 0){
            var modelS = actualUrl[actualUrl.indexOf("model")+1];
            var modelSelectedSplit = modelS.split(",");
                if(this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ] !== undefined)
                    return this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ];
                else
                    return null;
        }
        else if (this.gutembergOptions["model"] !== "all") {
          var model_name = this.gutembergOptions["model"]
          model_name = model_name.replace(/\s+/g, '-').toLowerCase();
          return this.imagesForModels[this.gutembergOptions["model"].toLowerCase()] || this.imagesForModels[model_name] ;
        }
        else
            return null;
    }else
        return null;

    },
    checkUrlExists(url) {
      url = url.replace("http:", "https:");
      return axios.head(url)
        .then(response => true) // URL válida
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return false; // URL no válida
          }
          return false; // Otro error
        });
    },
    toLeadboxImageUrl(src, size = '400-300') {
      if (!src) return null;

      if (src.includes('vehicleimages.leadboxhq.com')) {
        return src.replace('http:', 'https:');
      }
      const m = src.match(
        /https?:\/\/[^/]*blob\.core\.windows\.net\/([^/]+)\/vehicles\/([^/]+)\/pictures\/([a-f0-9-]+)(?:-[A-Z]+)?(?:\.\w+)?$/i
      );
      if (!m) return null;

      const dealer = m[1];
      const vehicleId = m[2];
      const imageId = m[3];

      return `https://vehicleimages.leadboxhq.com/v1/${dealer}/${vehicleId}/${imageId}-${size}.jpg`;
    },
    getFirstPicture(vehiclePicture, callback) {
      const leadboxUrl = this.toLeadboxImageUrl(vehiclePicture, '400');
      if (leadboxUrl) {
        callback(leadboxUrl);
        return;
      }

      if (vehiclePicture && EventBus.checkValidCDN(vehiclePicture)) {
        this.checkUrlExists(vehiclePicture).then(status => {
          let result;
          if (status) {
            if (vehiclePicture.includes('XXL')) {
              result = vehiclePicture.split('XXL').join('card.jpg').replace('http:', 'https:');
            } else if (vehiclePicture.includes('.png') || vehiclePicture.includes('invassets')) {
              result = vehiclePicture.replace('http:', 'https:');
            } else {
              result = vehiclePicture.replace('http:', 'https:') + '-card.jpg';
            }
          } else {
            console.info('** --> URL not found: ', vehiclePicture);
            result = vehiclePicture.split('-XXL').join('').replace('http:', 'https:');
          }
          callback(result); // Devolver el resultado a través del callback
        }).catch(error => {
          console.error('Error checking URL:', error);
          callback((vehiclePicture || '').replace('http:', 'https:')); // En caso de error, devolver la URL modificada
        });
      } else {
        callback((vehiclePicture || '').replace('http:', 'https:').replace('.jpg-XXL', '.jpg')); // Si no hay vehiclePicture o no es válido
      }
    },
    getFirstPictureWebp(vehiclePicture){
      if(vehiclePicture && EventBus.checkValidCDN(vehiclePicture)){
        if(vehiclePicture.includes('XXL'))
          return vehiclePicture.split('XXL').join('card.webp').replace("http:","https:")
        else if(vehiclePicture.includes('.png') || vehiclePicture.includes('invassets'))
          return vehiclePicture.replace("http:","https:");
        else
          return vehiclePicture.replace("http:","https:")+"-card.webp";
      }
      else{
        return vehiclePicture.replace("http:","https:");
      }
    },
    getSecondPicture(vehicleId) {
        if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo') || window.location.origin.includes("yorkdalelincoln")){
        var finalUrl = "";

        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');
          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPicture = finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPicture =  finalUrl.replace("http:","https:");
                else
                  this.secondPicture = finalUrl.replace("http:","https:")+"-card.jpg";
              }
              else{
                this.secondPicture = finalUrl.replace("http:","https:");
              }
            } else {
              finalUrl = this.templatedir;
              this.secondPicture = finalUrl;
            }
        });
    }
    return null;
    },
    getSecondPictureWebp(vehicleId) {
      if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo')){
        var finalUrl = "";

        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');
          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPictureWebp = finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPictureWebp =  finalUrl.replace("http:","https:");
                else
                  this.secondPictureWebp = finalUrl.replace("http:","https:")+"-card.webp";
              }
              else{
                this.secondPictureWebp = finalUrl.replace("http:","https:");
              }
            }
        });
    }
    return null;
    },
    getAllPictures(vehicleId) {
      if(vehicleId && vehicleId != undefined  && (this.galleryinteraction != '' && this.galleryinteraction == 'mini-gallery')  ){
        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');

          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              for(var i= 0; i < data.pictures.length; i++){
                if(data.pictures[i] && EventBus.checkValidCDN(data.pictures[i])){
                  if(data.pictures[i].includes('XXL'))
                    data.pictures[i] = data.pictures[i].split('XXL').join('card.jpg').replace("http:","https:");
                  else if(data.pictures[i].includes('.png') || data.pictures[i].includes('invassets') )
                    data.pictures[i] =  data.pictures[i].replace("http:","https:");
                  else
                    data.pictures[i] = data.pictures[i].replace("http:","https:")+"-card.jpg";
                }
                else{
                  data.pictures[i] = data.pictures[i].replace("http:","https:");
                }
              }

              setTimeout(() => {
                      if(!data.trim)
                        var dtrim = "";
                      else
                        var dtrim = data.trim.split(' ').join('-');

                      jQuery(".slick-gallery-"+vehicleId).not(".slick-initialized").slick({dots:!0,
                        nextArrow: "<button data-vehicle='"+data.condition+'-'+data.year+'-'+data.make+'-'+data.model.split(' ').join('-')+'-'+dtrim+'-'+data.stocknumber+"' class='slick-next slick-arrow' aria-label='Next' type='button'>Next</button>",
                        infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,responsive:[{breakpoint:1279,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}}]});
              },100);
              var allp = data.pictures.slice(0,11);
              this.allPictures = allp;
            } else
                this.allPictures = [this.templatedir];

            setTimeout(() => {
                var lazyImages = [].slice.call(document.querySelectorAll(".vehicle-card .main-img"));
                    if (!('IntersectionObserver' in window) ||
                    !('IntersectionObserverEntry' in window) ||
                    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        lazyImages.forEach(img => {
                            img.src = img.dataset.src;
                        });
                    }else{
                        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                            entries.forEach(function(entry) {
                                if (entry.isIntersecting) {
                                    let lazyImage = entry.target;
                                    lazyImage.src = lazyImage.dataset.src;
                                    lazyImageObserver.unobserve(lazyImage);
                                }
                            });
                        });

                        lazyImages.forEach(function(lazyImage) {
                        lazyImageObserver.observe(lazyImage);
                        });
                    }
             },100);

          })
      }
    },
    trackEventForm(formType) {
      var payload = {event_category: 'LBX-Form', event_label: 'LBX-Form-' + formType};
      window.sendGAEvent('LBX-View', payload);
    },
    imgLoadOnError(id) {
      //let newImage = this.templatedir;
      console.log("Error loading image: ", id);
       if(id){
        for (let i = 0; i < this.$refs[id+"vc-main-img"].length; i++) {
            //newImage = this.$refs[id + "vc-main-img"][i].getAttribute('data-src').replace("-card.jpg","");
            //console.log(this.$refs[id + "vc-main-img"][i].getAttribute('data-src').replace("-card.jpg",""));
            this.$refs[id+"vc-main-img"][i].src = this.templatedir;
          }
      }
      this.picture = this.templatedir;
    },
    FloorPlanLoadOnError(id) {
      if(this.$refs[id][0] && this.$refs[id][0].parentNode.parentNode) {
        this.$refs[id][0].parentNode.parentNode.remove();
      }
    },
    imgMiniGalleryLoadOnError(index, prefixLabel) {
      let prefix = (prefixLabel) ? prefixLabel : "mini_img_";
      this.$refs[prefix + index][0].src = this.templatedir;

      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.templatedir;

          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.templatedir;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.templatedir);
          }
        }
      }
    },
    imgLoadOnErrorSecondPicture() {
      this.secondPicture = this.templatedir;
    },
    goToCompare(id) {
      EventBus.$emit('goToCompare', id, this.lang);
    },
    isMoreThan(value1, value2) {
      return value1 > value2
    },
    isMoreOrEqualThan(value1, value2) {
      return value1 >= value2
    },
    isLessOrEqualThan(value1, value2) {
      return value1 <= value2
    },
    isLessThan(value1, value2) {
      return value1 < value2
    },
    isTrue(value) {
      return value;
    },
    sumValue(value1, value2) {
      return value1 + value2
    },
    subtractValue(value1, value2) {
      return value1 - value2
    },
    getRebateSign(value, type) {
      return value > 0 ? ( (type.toLowerCase() == 'increment' || type.toLowerCase() == 'luxury tax') ? '+' : '-') : '';
    },
    addCachebusterToken(url) {
      if (this.myCachebuster) {
          const currentHourTimestamp = Math.floor(Date.now() / 3600000);
          let storedTimestamp = localStorage.getItem('cachebusterTimestamp');

          if (!storedTimestamp || currentHourTimestamp !== parseInt(storedTimestamp, 10)) {
              storedTimestamp = currentHourTimestamp;
              localStorage.setItem('cachebusterTimestamp', storedTimestamp);
          }

          return `${url}?cb=${storedTimestamp}`;
      }
      return url; //* Si no está activado, devuelve la URL sin cambios
  },
  },
  computed: {
    vehicleTitle(){
      if(this.lang == 'fr-CA')
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
      else
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
    },
    viewSlug(){
      let slug = "/view/";
      if(this.lang == 'fr-CA')
        slug = "/vue/";

      let useVinSlug  = this.useVinSlug ? this.useVinSlug : false;
      return slug + this.vehicleSlugPart(useVinSlug) + "/"
    },
    discount(){
      let result = this.vehicle.saleprice - this.vehicle.price;
      return ((result > 0 ) ? result : 0);
    },
    showMSRP(){
      let result = (this.vehicle.saleprice && this.vehicle.saleprice > 0 && this.vehicle.saleprice > this.vehicle.price);
      return result;
    },
    loadingTemplate() {
      return `
      <div role="status" class="flex justify-center items-center">
        <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path class="fill-current text-primary"
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="none" />
        </svg>
      </div>
      <span class="flex justify-center items-center font-primary-bold loading-text">${
        this.lang == "en-CA" ? "Loading" : "Chargement"
      }...</span>`;
    },
  },
  filters: {
    moneyFormat:(price, lang, digits = 0)=>{
      var formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
      });
      return ( digits != 0) ? formatter.format(price) : formatter.format(Math.floor(price));
    },
    mileageFormat:(mileage,lang)=>{

      const formatter = new Intl.NumberFormat(lang, {
        style: 'unit',
        unit: 'kilometer'
      });

     return formatter.format(Math.floor(mileage));
    },
    replaceLiter:(string)=>{
      if(string)
        return string.replace("Liter","L").replace("liter","L").replace("litre","L").replace("Litre","L");
      else
        return "-";

    },
    stringReplace:(value, search, rep)=>{
      let replacement = '';
      if (typeof rep !== 'undefined' && !rep) {
        replacement = rep;
      }

      if (typeof value === 'undefined' || value === null)
        return "";
      else
        return value.replace(search,replacement);
    }
  }
}
